module.exports = __webpack_public_path__ + "static/media/check-box_on.6b9dcfa4.svg";